import { render, staticRenderFns } from "./TableItemUnit.vue?vue&type=template&id=70e9e55d"
import script from "./TableItemUnit.vue?vue&type=script&lang=js"
export * from "./TableItemUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports